// GENERIERT von scripts/gen-registry.ts – nicht bearbeiten, nicht einchecken.
import type { WebModule } from './module'
import m_assistant from '../modules/assistant/web/index'
import m_deposits from '../modules/deposits/web/index'
import m_einvoice from '../modules/einvoice/web/index'
import m_finance from '../modules/finance/web/index'
import m_inventory from '../modules/inventory/web/index'
import m_masterdata from '../modules/masterdata/web/index'
import m_platform from '../modules/platform/web/index'
import m_pos from '../modules/pos/web/index'
import m_pricing from '../modules/pricing/web/index'
import m_purchasing from '../modules/purchasing/web/index'
import m_reporting from '../modules/reporting/web/index'
import m_sales from '../modules/sales/web/index'
import m_stocktaking from '../modules/stocktaking/web/index'

/** Alle Oberflächen-Module in alphabetischer Reihenfolge der Modul-ID. */
export const webModules: readonly WebModule[] = [m_assistant, m_deposits, m_einvoice, m_finance, m_inventory, m_masterdata, m_platform, m_pos, m_pricing, m_purchasing, m_reporting, m_sales, m_stocktaking]
